import React, { Component } from 'react';
import { gettext } from '@eventbrite/i18n';
import { Button, SIZE_BLOCK } from '@eventbrite/eds-button';
import { withMainControls } from '@eventbrite/eds-structure';
import { Typography } from '@eventbrite/marmalade';
import { logEvent } from '@eventbrite/statsig';

import FormSubmitButton from '../../components/FormSubmitButton';

import './preAuthPage.scss';

class MfaEnrolmentPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
        };
    }

    componentDidMount() {
        // Reset loading state
        this.setState({ isLoading: false });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.email !== this.props.email) {
            this.setState({ isLoading: false });
        }
    }

    handleContinue = () => {
        this.setState({ isLoading: true });
        this.props.onContinue();

        // Reset loading state after 10 seconds to prevent it from staying in loading state
        this.loadingTimeout = setTimeout(() => {
            this.setState({ isLoading: false });
        }, 10000);
    };

    handleSkip = () => {
        this.setState({ isLoading: true });
        this.props.onSkip();

        // Reset loading state after 10 seconds to prevent it from staying in loading state
        this.loadingTimeout = setTimeout(() => {
            this.setState({ isLoading: false });
        }, 10000);
    };

    componentWillUnmount() {
        // Clean up loading timeout
        if (this.loadingTimeout) {
            clearTimeout(this.loadingTimeout);
        }
    }

    render() {
        const { isLoading } = this.state;
        const { email } = this.props;

        return (
            <div className="eds-structure eds-structure--min-height preAuth__page-bg eds-align--center">
                <div className="mfa_preAuth__box">
                    <div className="mfa_internal-page">
                        <div className="internal-page__logo">
                            <img
                                src="https://cdn.evbstatic.com/s3-build/perm_001/89f846/django/images/email/base/big-brand.png"
                                alt="Brand logo"
                                style={{ maxHeight: '28px', maxWidth: '100%' }}
                            />
                        </div>
                        <div className="internal-page__content">
                            <h1 className="eds-l-mar-top-10">
                                {gettext('Add extra security to your account')}
                            </h1>
                            <div className="eds-l-mar-top-4 eds-l-mar-bot-6">
                                <Typography
                                    as="p"
                                    color="neutral-600"
                                    variant="body-md"
                                    className="eds-text--center"
                                >
                                    {gettext(
                                        "Let's make your account safer by adding more ways to confirm it's really you.",
                                    )}
                                </Typography>
                            </div>
                            <div className="eds-l-mar-top-8 eds-l-mar-bot-4">
                                <FormSubmitButton
                                    buttonClasses="preAuth__btn"
                                    buttonCTA={gettext('Continue')}
                                    onClick={this.handleContinue}
                                    submitDisabled={isLoading}
                                    isLoading={isLoading}
                                />
                            </div>
                            <div className="eds-l-mar-top-4 eds-l-mar-bot-6">
                                <Button
                                    data-testid="mfa-enrollment-skip-button"
                                    type="button"
                                    size={SIZE_BLOCK}
                                    onClick={this.handleSkip}
                                    disabled={isLoading}
                                    style="neutral"
                                >
                                    {gettext('Skip')}
                                </Button>
                            </div>
                            <div className="eds-l-mar-top-2 eds-l-mar-bot-4 eds-align--center eds-text--center">
                                <Typography
                                    className="preAuth__secondary-text"
                                    as="p"
                                    color="primary"
                                    variant="body-sm"
                                >
                                    {gettext(
                                        'If you skip this, we’ll remind you later to add extra security.',
                                    )}
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withMainControls(MfaEnrolmentPage);
